import { apiRequest, apiRequestPaginated } from './client';
import type { Payment } from '../types';

type ApiPaymentJob = {
  _id: string;
  title?: string;
  budget?: number;
  estimatedStartDate?: string;
  user?: { _id?: string; name?: string | null } | null;
  provider?: { _id?: string; name?: string | null } | null;
};

type ApiPendingPayment = {
  _id: string;
  adminApproved?: boolean;
  additionalService?: { _id?: string; title?: string } | null;
  job?: ApiPaymentJob | null;
};

export const mapApiPayment = (item: ApiPendingPayment): Payment => ({
  id: item._id,
  jobId: item.job?._id || '—',
  customerId: item.job?.user?._id || '',
  customerName: item.job?.user?.name || '—',
  providerId: item.job?.provider?._id || '',
  providerName: item.job?.provider?.name || '—',
  amount: Number(item.job?.budget) || 0,
  method: item.additionalService?.title || '—',
  date: item.job?.estimatedStartDate || '',
  status: 'Pending',
});

export const paymentsApi = {
  getJobPayments: async (params?: {
    page?: number;
    limit?: number;
  }): Promise<{ payments: Payment[]; total: number }> => {
    const query = new URLSearchParams({
      page: String(params?.page || 1),
      limit: String(params?.limit || 1000),
    });

    const { data, pagination } = await apiRequestPaginated<{
      pendingPaymentJobs: ApiPendingPayment[];
    }>(`/admin/payments/get-job-payments?${query.toString()}`, {
      method: 'GET',
      auth: true,
    });

    return {
      payments: (data.pendingPaymentJobs || []).map(mapApiPayment),
      total: pagination.totalItems || 0,
    };
  },

  getJobPaymentDetails: async (transactionID: string): Promise<Payment> => {
    const data = await apiRequest<{ jobTransaction: ApiPendingPayment }>(
      `/admin/payments/get-job-details/${transactionID}`,
      { method: 'GET', auth: true }
    );
    if (!data.jobTransaction) throw new Error('Payment not found');
    return mapApiPayment(data.jobTransaction);
  },

  payProvider: async (transactionID: string): Promise<void> => {
    await apiRequest(`/admin/payments/pay-provider?transactionID=${transactionID}`, {
      method: 'POST',
      auth: true,
    });
  },
};
